import { Alert, AlertTitle } from '@mui/material';
import { Agandeform } from '../../types/dtos/VarderingarModel';

interface ValidationMessageProps {
  agandeform: Agandeform;
}

export const ValidationMessage: React.FC<ValidationMessageProps> = ({
  agandeform,
}) => {
  const messages: JSX.Element[] = [];

  switch (agandeform) {
    case Agandeform.hyresrätt:
      messages.push(
        <Alert severity="warning">
          <AlertTitle>Observera</AlertTitle>Bostadens ägandeform är{' '}
          {Agandeform.hyresrätt.toLowerCase()}. Du kan fortfarande genomföra
          värderingen men behöver minst ange bostadskategori och boarea.
        </Alert>
      );
      break;
  }

  if (messages.length === 0) {
    return null;
  } else {
    return <>{messages}</>;
  }
};
